import { AxiosResponse } from "axios";
import API from "../api";
import { Options } from "./_base";
import { Company } from "Models/company";

const endpoint = "company-connections";

const CompanyConnectionsService = {
  getList(options?: Options<any>) {
    return API.get(`/${endpoint}`, { params: options });
  },

  getCompaniesWithConnection(options?: Options<any>): Promise<AxiosResponse<Company[]>> {
    return API.get(`/${endpoint}/companies-with-connection`, { params: options });
  }
};

export { CompanyConnectionsService };
